import { Box, FormControl } from '@primer/react';
import React from 'react';
import { Controller, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { IHocSinh } from '../../../models/response/crm-hocsinh/IHocsinh';
import FormBlock from './FormBlock';
import TextInput from '../../../components/ui/text-input';
import { ComboboxNguonBietToi } from '../../../components/combobox-nguonbiettoi';
import ComboBoxDieuPhoiVien from '../../../components/combobox-dieuphoivien';
import { useCommonSelectedHook } from '../../../hooks/useCommonSelectedHook';

interface IThongTinKhacProps {
    control: any,
    hocSinh: IHocSinh,
    setFormData: React.Dispatch<React.SetStateAction<IHocSinh>>,
    setValue: UseFormSetValue<IHocSinh>,
    register: any,
    errors: any,
    formData: IHocSinh,
    trigger: UseFormTrigger<IHocSinh>,
}

const errorComboSx = {
    "& button": {
        borderColor: "danger.emphasis !important",
        boxShadow: "0 0 0 1px #cf222e",
    },
};

const requiredStar = <Box as="span" sx={{ color: "danger.fg" }}> *</Box>;

const ThongTinKhac = (props: IThongTinKhacProps) => {
    const { control, setFormData, register, errors } = props;
    const { dm_coso_id } = useCommonSelectedHook();

    return (
        <FormBlock caption="Thông tin khác">
            <Box sx={{
                display: "grid",
                gap: 2
            }}>
                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(4,1fr)" }}>
                    <FormControl>
                        <FormControl.Label>Mã định danh cá nhân</FormControl.Label>
                        <TextInput
                            block
                            name="ma_dinh_danh"
                            register={register}
                            errors={errors}
                            required={false}
                            validateMessage="Vui lòng điền mã định danh"
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Mã định danh CSDL</FormControl.Label>
                        <TextInput
                            block
                            name="ma_dinh_danh_csdl"
                            register={register}
                            errors={errors}
                            required={false}
                            validateMessage="Vui lòng điền mã định danh CSDL"
                        />
                    </FormControl>

                    <Controller
                        name="dm_nguonbiettoi_id"
                        control={control}
                        rules={{
                            required: "Vui lòng chọn nguồn biết tới",
                            validate: (v: any) => Number(v) > 0 || "Vui lòng chọn nguồn biết tới",
                        }}
                        render={({ field }) => (
                            <FormControl>
                                <FormControl.Label>Nguồn biết tới{requiredStar}</FormControl.Label>
                                <Box sx={errors.dm_nguonbiettoi_id ? errorComboSx : undefined}>
                                    <ComboboxNguonBietToi
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            setFormData((prev) => ({
                                                ...prev,
                                                dm_nguonbiettoi_id: value,
                                            }));
                                        }}
                                    />
                                </Box>
                                {errors.dm_nguonbiettoi_id && (
                                    <FormControl.Validation variant="error">
                                        {errors.dm_nguonbiettoi_id.message}
                                    </FormControl.Validation>
                                )}
                            </FormControl>
                        )}
                    />
                    <FormControl>
                        <FormControl.Label>Mã số BHYT</FormControl.Label>
                        <TextInput
                            block
                            name="ma_so_bhyt"
                            register={register}
                            errors={errors}
                            required={false}
                        />
                    </FormControl>
                </Box>
                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr 1fr 2fr" }}>
                    <Controller
                        name="dieu_phoi_vien_id"
                        control={control}
                        render={({ field }) => (
                            <FormControl>
                                <FormControl.Label>Điều phối viên</FormControl.Label>
                                <ComboBoxDieuPhoiVien
                                    role_dpv_id={43}
                                    dm_coso_id={dm_coso_id}
                                    value={field.value}
                                    onValueChanged={(value) => {
                                        field.onChange(value);
                                        setFormData((prev) => ({
                                            ...prev,
                                            dieu_phoi_vien_id: value,
                                        }));
                                    }}
                                />
                                {errors.dieu_phoi_vien_id && (
                                    <FormControl.Validation variant="error">
                                        {errors.dieu_phoi_vien_id.message}
                                    </FormControl.Validation>
                                )}
                            </FormControl>
                        )}
                    />
                    <FormControl>
                        <FormControl.Label>Trường cũ</FormControl.Label>
                        <TextInput
                            block
                            name="truong_hoc_cu"
                            register={register}
                            errors={errors}
                            required={false}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Ghi chú chung</FormControl.Label>
                        <TextInput
                            block
                            name="ghi_chu_chung"
                            register={register}
                            errors={errors}
                            required={false}
                        />
                    </FormControl>
                </Box>
                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(3,1fr)" }}>
                    <FormControl>
                        <FormControl.Label>Lưu ý sức khỏe</FormControl.Label>
                        <TextInput
                            block
                            name="luu_y_suc_khoe"
                            register={register}
                            errors={errors}
                            required={false}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Lưu ý ăn uống</FormControl.Label>
                        <TextInput
                            block
                            name="luu_y_an_uong"
                            register={register}
                            errors={errors}
                            required={false}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Tình trạng bán trú</FormControl.Label>
                        <TextInput
                            block
                            name="tinh_trang_ban_tru"
                            register={register}
                            errors={errors}
                            required={false}
                        />
                    </FormControl>
                </Box>
                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(3,1fr)" }}>
                    <FormControl>
                        <FormControl.Label>Đăng ký bus</FormControl.Label>
                        <TextInput
                            block
                            name="dang_ky_bus"
                            register={register}
                            errors={errors}
                            required={false}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Hình thức đón/trả</FormControl.Label>
                        <TextInput
                            block
                            name="hinh_thuc_don_tra"
                            register={register}
                            errors={errors}
                            required={false}
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Đăng ký gửi xe đạp</FormControl.Label>
                        <TextInput
                            block
                            name="gui_xe_dap"
                            register={register}
                            errors={errors}
                            required={false}
                        />
                    </FormControl>
                </Box>
            </Box>
        </FormBlock>
    );
};

export default ThongTinKhac;
